import { TZDate } from '@date-fns/tz';
import { fromUnixTime, isAfter, isBefore, isSameDay } from 'date-fns';
import type { components } from '#/types/api/zenid-mypage-api';
import { NFDW_EDU_ZEN_UNIVERSITY } from '#/utils/constants';

/**
 * 日本標準時のタイムゾーン
 */
const JST = 'Asia/Tokyo';

function validRole(roleAssigning: components['schemas']['InternalAPI.Models.RoleAssigning']) {
  const currentDate = new TZDate().withTimeZone(JST);
  const fromDate = new TZDate(fromUnixTime(roleAssigning.from), JST);
  if (roleAssigning.to) {
    const toDate = new TZDate(fromUnixTime(roleAssigning.to), JST);
    // ロールがメンバーシップに含まれている場合、そのロールが有効状態を判断する
    // ロールが有効であれば所属情報に載せない、無効であれば載せる
    return (
      ((isSameDay(currentDate, fromDate) || isAfter(currentDate, fromDate)) && isSameDay(currentDate, toDate)) ||
      isBefore(currentDate, toDate)
    );
  }
  // toがない場合は、fromを達しているかで判断し有効範囲内としてtrueとする
  return isSameDay(currentDate, fromDate) || isAfter(currentDate, fromDate);
}

/**
 * 所属情報を表示有無を判定する関数
 *
 * 出願者または保証人の場合は所属情報は表示させない
 *
 * @param memberships メンバーシップ情報
 * @returns
 */
export function shouldShowOrganizations(memberships: Array<components['schemas']['AdminAPI.Models.Membership']>) {
  const existsApplicantOrGaruntor = memberships.some((membership) =>
    membership.roleAssignings.some((roleAssigning: components['schemas']['InternalAPI.Models.RoleAssigning']) => {
      if (roleAssigning.name === NFDW_EDU_ZEN_UNIVERSITY.APPLICANT) {
        return validRole(roleAssigning);
      }

      if (roleAssigning.name === NFDW_EDU_ZEN_UNIVERSITY.GUARANTOR) {
        return true;
      }
      return false;
    })
  );
  // 出願者または保証人が存在している場合は所属情報を表示させないのでfalseで返す
  return !existsApplicantOrGaruntor;
}
